export const queryKeys = {
  promoterGroupsRoot: () => ["promoterGroups"] as const,
  promoterGroups: (cityId?: string | null) =>
    ["promoterGroups", cityId ?? "current"] as const,
  acceptedGroups: () => ["acceptedGroups"] as const,
  promoterGroup: (groupId?: string | null) =>
    ["promoterGroup", groupId ?? ""] as const,
  myParties: () => ["myParties"] as const,
  myParty: (groupId?: string | null) => ["myParty", groupId ?? ""] as const,
  alsoGoingOutGroupsRoot: () => ["alsoGoingOutGroups"] as const,
  alsoGoingOutGroups: (cityId?: string | null) =>
    ["alsoGoingOutGroups", cityId ?? "current"] as const,
  chatMessages: (offerId?: string | null) => ["chatMessages", offerId ?? ""] as const,
  openClubListings: (
    city?: string | null,
    partyDate?: Date | string | null,
    bookingType?: string | number | null
  ) =>
    [
      "openClubListings",
      city ?? "",
      partyDate ? new Date(partyDate).toISOString() : "",
      bookingType ?? "",
    ] as const,
};
